import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import { Button } from '../components/UI';
import Logo from '../components/Logo';

const Gracias = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 text-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <Logo size="large" />
        </div>
        
        <div className="bg-white text-gray-900 rounded-lg p-12 shadow-2xl">
          <div className="text-6xl mb-6">✅</div>
          
          <h1 className="text-4xl font-bold mb-4 text-purple-900">
            {t('thankYouTitle')}
          </h1>
          
          <p className="text-xl text-gray-700 mb-8">
            {t('thankYouMessage')}
          </p>
          
          <Link to="/">
            <Button className="bg-yellow-500 hover:bg-yellow-600 text-black text-lg px-8 py-4 font-bold">
              {t('backToHome')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Gracias;
